// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36GLA","footer":"styles_footer__SxQ-X"};